import React, { useMemo, useState } from "react";
import { AsideMenuList } from "./AsideMenuList";
import { useHtmlClassService } from "../../../_core/MetronicLayout";
import { config } from "../../../../../services/config";
import { FiSearch } from "react-icons/fi";
import "./sidebar-enhancements.css";

export function AsideMenu({ disableScroll }) {
  const [menuSearch, setMenuSearch] = useState("");
  const uiService = useHtmlClassService();
  const layoutProps = useMemo(() => {
    return {
      layoutConfig: uiService.config,
      asideMenuAttr: uiService.getAttributes("aside_menu"),
      ulClasses: uiService.getClasses("aside_menu_nav", true),
      asideClassesFromConfig: uiService.getClasses("aside_menu", true),
    };
  }, [uiService]);

  return (
    <>
      {/* begin::Menu Container */}
      <div
        // style={{backgroundColor:"#05054b"}}
        id="kt_aside_menu"
        style={{ background: "transparent" }}
        data-menu-vertical="1"
        className={`aside-menu my-4 ${layoutProps.asideClassesFromConfig}`}
        {...layoutProps.asideMenuAttr}
      >
        <div className="aside-menu-search">
          <FiSearch className="aside-menu-search-icon" aria-hidden="true" />
          <input
            aria-label="Search menu items"
            className="aside-menu-search-input"
            placeholder="Search menu..."
            type="search"
            value={menuSearch}
            onChange={(event) => setMenuSearch(event.target.value)}
          />
        </div>
        <AsideMenuList layoutProps={layoutProps} searchQuery={menuSearch} />
      </div>
      {/* end::Menu Container */}
    </>
  );
}
